import { ConnectionService } from "../../api.service";
import router from "../../router.js";

export default {
  namespaced: true,
  state: {
    items: [],
    pagination: {
      currentPage: 1,
      limit: 50,
      totalRows: 0
    },
    connection: [],
    types: []
  },
  getters: {},
  actions: {
    fetch: ({ commit, state, rootState }) => {
      if (rootState.organizationSelected === '-1') {
        return false;
      }

      let params = {
        id: rootState.organizationSelected,
        limit: state.pagination.limit,
        page: state.pagination.currentPage,
        resource: "organization",
        list: "connection"
      };
      return ConnectionService.getByCriteria(params)
        .then(res => {
          commit("SET_CONNECTIONS", res.data.data.connections.data);
          commit("SET_PAGINATION", res.data.data.connections);
        })
        .catch(error => {
          return error;
        });
    },
    fetchAll: ({ dispatch, state }) => {
      state.pagination.limit = 10000000;
      return dispatch("fetch");
    },
    show: ({ commit }, slug) => {
      return ConnectionService.get(slug)
        .then(res => {
          commit("SET_CONNECTION", res.data.data.connection);
        })
        .catch(error => {
          commit("SET_EXCEPTIONS", error.response.data, { root: true });
        });
    },
    checkStatus: ({ commit }, payload) => {
      commit("SET_STATUS", { index: payload.index, status: null });
      return ConnectionService.get(payload.slug)
        .then(res => {
          commit("SET_STATUS", {
            index: payload.index,
            status: res.data.data.connection.status
          });
        })
        .catch(error => {
          commit("SET_EXCEPTIONS", error.response.data, { root: true });
        });
    },
    create: ({ dispatch, rootState }, payload) => {
      payload.organization_id = rootState.organizationSelected;
      return ConnectionService.create(payload)
        .then(res => {
          dispatch("setSuccess", res.data.message, { root: true });
          router.replace({ name: "connection" });
        })
        .catch(error => {
          dispatch("setExceptions", error.response.data, { root: true });
        });
    },
    edit: ({ dispatch }, payload) => {
      if (
        payload.connection.password === null ||
        payload.connection.password === ""
      ) {
        delete payload.connection.password;
      }
      return ConnectionService.update(payload.id, payload.connection)
        .then(res => {
          dispatch("setSuccess", res.data.message, { root: true });
          router.replace({ name: "connection" });
        })
        .catch(function(error) {
          dispatch("setExceptions", error.response.data, { root: true });
        });
    },
    remove: ({ dispatch, commit }, payload) => {
      return ConnectionService.destroy(payload.id)
        .then(res => {
          dispatch("setSuccess", res.data.message, { root: true });
          return dispatch("fetch");
        })
        .catch(error => {
          dispatch("setExceptions", error.response.data, { root: true });
        });
    },
    getTypes: ({ commit }) => {
      return ConnectionService.get("types")
        .then(res => {
          commit("SET_TYPES", res.data.data.types);
        })
        .catch(error => {
          commit("SET_EXCEPTIONS", error.response.data);
        });
    },
    checkConnection: ({ commit, dispatch }, payload) => {
      return ConnectionService.post("connection/test", payload)
        .then(res => {
          dispatch("setSuccess", "Connection working", { root: true });
        })
        .catch(error => {
          dispatch(
            "setExceptions",
            { message: error.response.data.message, data: { } },
            { root: true }
          );
        });
    }
  },
  mutations: {
    SET_CONNECTIONS: (state, connections) => {
      state.items = connections;
    },
    SET_CONNECTION: (state, connection) => {
      state.connection = connection;
    },
    SET_PAGINATION: (state, element) => {
      state.pagination.currentPage = element.current_page;
      state.pagination.totalRows = element.total;
    },
    SET_STATUS: (state, payload) => {
      state.items[payload.index].status = payload.status;
    },
    SET_STATUS_LOADING: (state, payload) => {
      state.items[payload.index].isRunning = payload.running;
    },
    SET_CURRENT_PAGE: (state, page) => {
      state.pagination.currentPage = page;
    },
    SET_TYPES: (state, types) => {
      state.types = types;
    }
  }
};
